export const PERPETUAL = 'perpetual'
